export default __webpack_public_path__ + "static/media/calenderIcon.25193bd1.svg";